import { ContentQueryParams } from './content-query-params.type';

export type Routable = {
  to?: string;
  content?: ContentQueryParams;
}
